import { Button, ButtonGroup, Tooltip } from '@material-ui/core';
import React from 'react';

interface ChartExportButtonsProps {
    isExporting: boolean;
    onExportPng: () => Promise<void> | void;
    onExportSvg: () => Promise<void> | void;
    disabled?: boolean;
}

export const ChartExportButtons: React.FC<ChartExportButtonsProps> = ({
    disabled,
    isExporting,
    onExportPng,
    onExportSvg
}) => {
    const isDisabled = !!disabled || isExporting;
    return (
        <div className="chart-export-buttons" style={{ display: 'flex' }}>
            <ButtonGroup size="small" variant="text">
                <Tooltip title="Download PNG">
                    <Button size="small" onClick={onExportPng} disabled={isDisabled} className="chart-export-button">
                        PNG
                    </Button>
                </Tooltip>
                <Tooltip title="Download SVG">
                    <Button size="small" onClick={onExportSvg} disabled={isDisabled} className="chart-export-button">
                        SVG
                    </Button>
                </Tooltip>
            </ButtonGroup>
        </div>
    );
};
